<template>
    <va-edit-layout>
        <ChargebackEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></ChargebackEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
